module.exports = __webpack_public_path__ + "img/02.5d52e514.jpg";